import { Controller } from "@hotwired/stimulus"

// Controla el form de datos de facturacion:
// - Toggle de seccion invoice/ballot segun el radio :type
// - Cascada region -> comuna usando el catalogo embebido en data-...-regions-value
export default class extends Controller {
  static targets = ["type", "invoiceSection", "region", "comuna"]
  static values = { regions: Array }

  connect() {
    this._syncInvoiceVisibility()
  }

  toggleType() {
    this._syncInvoiceVisibility()
  }

  updateComunas() {
    if (!this.hasRegionTarget || !this.hasComunaTarget) return

    const selectedRegion = this.regionTarget.value
    const region = this.regionsValue.find((r) => r.region === selectedRegion)
    const comunas = region ? region.comunas : []

    const placeholder = this.comunaTarget.querySelector("option[value='']")
    this.comunaTarget.innerHTML = ""
    if (placeholder) this.comunaTarget.appendChild(placeholder)

    comunas.forEach((c) => {
      const opt = document.createElement("option")
      opt.value = c.name
      opt.textContent = c.name
      this.comunaTarget.appendChild(opt)
    })
  }

  _syncInvoiceVisibility() {
    if (!this.hasInvoiceSectionTarget) return

    const selected = this._selectedType()
    const isInvoice = selected === "invoice"
    this.invoiceSectionTarget.classList.toggle("hidden", !isInvoice)
  }

  _selectedType() {
    const checked = this.typeTargets.find((el) => el.checked)
    return checked ? checked.value : null
  }
}
